import { Component, OnInit } from '@angular/core';
import {DEFAULT_POWER, Psu} from "../shared/model/psu";
import {Field} from "../shared/model/field";
import {Cpu} from "../shared/model/cpu";
import {CpusService} from "../shared/model/cpus.service";
import {Observable} from "rxjs/Rx";
import {AuthService} from "../shared/security/auth.service";
import {CommandService} from "../shared/model/command.service";
import {FieldsService} from "../shared/model/fields.service";
import {PsusService} from "../shared/model/psus.service";
import {TranslateService} from "@ngx-translate/core";
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  clubId: string;
  clubName: string;
  currentRole: string;

  fields$: Observable<Field[]>;
  usesField: string;

  selectedRow: number;
  selectedField: Field;
  selectedCpu: Cpu;
  selectedPsu: Psu;

  serialNr: string;
  burnTime: number;

  // flags to display modal windows
  showDetailPsu: boolean = false;
  showPowerOnPsu: boolean = false;
  showPsuAddress: boolean =false;
  showProcessParams: boolean = false;

  showConfirmation: boolean = false;
  showDetail: boolean = false;

  powerOnClubId: string;
  powerOnFieldId: string;
  powerOnCpuId: string;
  powerOnPsuId: number;
  powerOnValue: number;
  powerOnPsuDescription: string;

  env_prod = 1;
  username = "";
  password = "";
  up: string = "";
  down: string = "";
  baudrate: number = 56700;
  apn: string = 'data.mono';
  driverType = 'Type 2 driver';
  paramsString: string = "";
  confirmationTitle: string = "";

  dbPath: string = "";

  constructor(private fieldsService: FieldsService, private authService: AuthService, private psusService: PsusService,
              private cpusService: CpusService, private commandService: CommandService, private translate: TranslateService) {
  }

  ngOnInit() {
    this.clubId = this.authService.getClubIdForUser();
    this.clubName = this.authService.getClubNameForUser();
    this.fields$ = this.fieldsService.findFieldsForClubId(this.clubId);
    this.currentRole = this.authService.getUserRole();

    this.fields$.subscribe(
      fields => console.log,
      error => console.log
    );
  }

  getPsuType( psu: Psu ): string {
    const p = psu.factoryPower;

    if ( p >= 200 && p <= 240 ) {
      return "V2, 500 W";
    } else if ( p >= 410 && p <= 420 ) {
      return "V2, 1000 W";
    } else if ( p >= 620 && p <= 640 ) {
      return "V2, 1500 W"
    } else if ( p >= 735 && p <= 750 ) {
      return "V2, 1800 W"
    } else if ( p >= 825 && p < 840 ) {
      return "V2, 2000 W"
    } else {
      return "--?--";
    }
  }

  setSelectedField(row: number, fieldId: string) {
    this.selectedRow = row;
    let clubId = this.authService.getClubIdForUser();

    this.fieldsService.findFieldForClubIdAndFieldId(clubId, fieldId).subscribe(
      field => this.selectedField = field,
      error => console.error
    );
  }

  showPsuDetail(field: Field, cpuId: string, psu: Psu, usesField: string) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + field.$key + '/cpus/' + cpuId + '/psus/' + psu.$key;
    this.selectedField = field;
    this.usesField = usesField;

    this.selectedPsu = new Psu(psu.$key, psu.description, psu.defaultPower, psu.power, psu.overboost, psu.percentagePower, psu.installationDate, psu.soll, psu.ist,
      psu.serialNr, psu.burnTime, psu.powerConsumption, psu.outVoltage12, psu.outVoltage34, psu.current, psu.inputVoltage, psu.driverTemp, psu.caseTemp,
      psu.led1Temp, psu.led2Temp, psu.powerOnValue, psu.statusReport, psu.errorStatus, psu.errorLog, psu.factoryPower);
    this.showModalPsuDetailWindow(true);
  }

  showPsuAddressWindow(fieldId: string, cpuId: string, psuId: string, psuDescription: string) {
    this.powerOnClubId = this.authService.getClubIdForUser();
    this.powerOnFieldId = fieldId;
    this.powerOnCpuId = cpuId;
    this.powerOnPsuId = parseInt(psuId);
    this.powerOnPsuDescription = psuDescription;

    this.showModalPsuAddressWindow(true);
  }

  getPower(fieldId: string, cpuId: string, psu: Psu, usesField: null) {
    let clubId = this.authService.getClubIdForUser();
    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_OUTPUT_SCALAR", -1, false, usesField, this.authService.getUserName());
  }

  getStatusReport(fieldId: string, cpuId: string, psu: Psu) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + fieldId + '/cpus/' + cpuId + '/psus/' + psu.$key;
    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_STATUS_REPORT", -1, false, null, this.authService.getUserName());
  }

  getErrorStatus(fieldId: string, cpuId: string, psu: Psu) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + fieldId + '/cpus/' + cpuId + '/psus/' + psu.$key;
    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_ERROR_STATUS", -1, false, null, this.authService.getUserName());
  }

  getErrorLog(fieldId: string, cpuId: string, psu: Psu) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + fieldId + '/cpus/' + cpuId + '/psus/' + psu.$key;
    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_ERROR_LOG", -1, false, null, this.authService.getUserName());
  }

  getPwm(fieldId: string, cpuId: string, psu: Psu, usesField: string) {
    let clubId = this.authService.getClubIdForUser();
    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_PWM", -1, false, usesField, this.authService.getUserId());
  }

  getBurnTime(fieldId: string, cpuId: string, psu: Psu) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + fieldId + '/cpus/' + cpuId + '/psus/' + psu.$key;

    this.psusService.updatePsuBurnTime(this.dbPath, 0);


    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_BURN_TIME", -1, false, fieldId, this.authService.getUserName());
  }

  getPowerConsumption(fieldId: string, cpuId: string, psu: Psu) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + fieldId + '/cpus/' + cpuId + '/psus/' + psu.$key;

    this.psusService.updatePsuPowerConsumption(this.dbPath, 0);


    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_POWER_STATUS", -1, false, fieldId, this.authService.getUserName());
  }

  getTemperature(fieldId: string, cpuId: string, psu: Psu) {
    let clubId = this.authService.getClubIdForUser();
    this.dbPath = clubId + '/' + fieldId + '/cpus/' + cpuId + '/psus/' + psu.$key;

    this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psu.$key), "GET_TEMP_STATUS", -1, false, fieldId, this.authService.getUserName());
  }


  showModalConfirmationWindow(show: boolean) {
    this.showConfirmation = show;
  }

  showModalDetailWindow(show: boolean) {
    this.showDetail = show;
  }

  showModalPsuAddressWindow(show: boolean) {
    this.showPsuAddress = show;
  }

  getPowerOnValue(fieldId: string, cpuId: string, psuId: string, usesField: string, psuDescription: string) {
    let clubId = this.authService.getClubIdForUser();
    let isNewDriver = psuDescription.startsWith('1');

    //console.log(`in getPowerOnValue with isNewDriver: ${isNewDriver}`);

    if ( isNewDriver ) {
      this.commandService.addCommand(clubId, fieldId, cpuId, parseInt(psuId), "GET_POWER_ON_VALUE", -1, false, usesField, this.authService.getUserName());
    }
  }

  hasPowerOn(version: string) {
    if(version.startsWith('1')) {
      return true;
    } else {
      return false;
    }
  }

  showPowerOnValue(fieldId: string, cpuId: string, psuId: string, powerOnValue: number, psuDescription: string) {
    this.powerOnClubId = this.authService.getClubIdForUser();
    this.powerOnFieldId = fieldId;
    this.powerOnCpuId = cpuId;
    this.powerOnPsuId = parseInt(psuId);
    this.powerOnValue = powerOnValue;
    this.powerOnPsuDescription = psuDescription;

    this.showModalPsuPowerOnWindow(true);
  }

  showModalPsuPowerOnWindow(show: boolean) {
    this.showPowerOnPsu = show;
  }

  processPsuPowerOnChange(result: boolean) {  // callback from modal window to close it
    this.showModalPsuPowerOnWindow(result);
  }

  processPsuAddressChange (result: boolean) {
    this.showModalPsuAddressWindow(result);
  }

  showModalPsuDetailWindow(show: boolean) {
    this.showDetailPsu = show;
  }

  lastSeen(ls: string): string {
    let lastSeen = undefined;
    let ts = parseInt(ls);
    if(ts.toString() !== "NaN") {
      let dt = new Date(ts);
      lastSeen = dt.toLocaleString('nl-NL');
    }
    return lastSeen;
  }

  parseRSSI(rssiString: string) : string {
    let rssi = parseInt(rssiString);
    if(rssi <= -95) {
      return "Marginal";
    } else if(rssi <= -85) {
      return "OK";
    } else if(rssi <= -75) {
      return "Good";
    } else if(rssi > -75) {
      return "Excellent";
    } else {
      return "Unknown";
    }
  }

  generateParamsFile(fieldId: string, fieldName: string, cpuId: string, cpuDescription: string, psuDescription: string) {
    this.translate.get('l.paramsh')
      .subscribe((res: string) => {
        this.confirmationTitle = res;
        this.translate.get('l.paramshmsg')
          .subscribe((res2: string) => {
            this.username = this.authService.getClubIdForUser();
            this.password = this.username.split('').reverse().join('');
            if ( !psuDescription.startsWith('1') ) {
              this.driverType = 'Type 1 driver';
              this.baudrate = 9600;
            }
            this.confirmationTitle +=  ' - ' + this.driverType;
            const path = `${this.username}/${fieldId}/${cpuId}`;
            this.up = `up/${path}`;
            this.down = `down/${path}`;
            this.paramsString = `#define P_ENV_PROD ${this.env_prod}
#define P_USERNAME \"${this.username}\"
#define P_PASSWORD \"${this.password}\"
#define P_UP \"${this.up}\"
#define P_DOWN \"${this.down}\"
#define P_BAUDRATE ${this.baudrate}
#define P_APN \"${this.apn}\"
/* Club: ${this.authService.getClubForUser()}, Field: ${fieldName}, RF: ${cpuDescription} */
`;
            //console.log(this.paramsString);
            this.showProcessParams = true;
          });
      });
  }

  showModalGenerateParamsFileWindow(show: boolean) {
    this.showProcessParams = show;
  }

  processParamsFile(result: boolean) {
    this.showModalGenerateParamsFileWindow( false );

    if (result) {
      const blob = new Blob([this.paramsString], {type: 'text/plain;charset=utf-8'});
      saveAs(blob, 'params.h');
    }
  }

}
